@if (label()) {
  <label class="form-label text-body-sm-500" [innerHTML]="label()"> </label>
  @if (requiredLabel()) {
    <span class="text-danger"> *</span>
  }
}
<p-inputgroup>
  <p-inputNumber
    [id]="id()"
    mode="currency"
    [currency]="currencyCode()"
    [placeholder]="placeholder()"
    class="w-100"
    [ngModel]="value()"
    (ngModelChange)="onModelChange($event)"
    (input)="onInputChange($event)"
    (keydown)="onKeyDown($event)"
    (paste)="onPaste($event)"
    (onBlur)="onBlur()"
    (onFocus)="onFocus()"
    [disabled]="isDisabled()"
    [attr.aria-label]="label() || 'Amount'"
    [min]="min()"
    [max]="max()"
  />
  @if (uomSuffix()) {
    <p-inputgroup-addon class="text-[14px] !text-[#64748B] py-0 !bg-[#F5F5F4]">/{{ uomSuffix() }}</p-inputgroup-addon>
  }
</p-inputgroup>

<!-- @if (showError()) {
  <div class="text-danger">
    <span>{{ errormessage() }}1</span>
  </div>
} -->
@if (ngControl?.touched && ngControl?.invalid) {
  <div class="text-danger">
    <span>{{ errormessage() }}</span>
  </div>
}
